module.exports = __webpack_public_path__ + "img/trial.9b23efa1.png";